import React from 'react';

// Click-to-sort table header (same arrows as the People list): idle = ↕ dim, active = ↑ / ↓.
// First click on a column sorts ascending, the next click flips it.
export const nextSort = ({ sortBy, sortOrder }, field) =>
  sortBy === field
    ? { sortBy, sortOrder: sortOrder === 'asc' ? 'desc' : 'asc' }
    : { sortBy: field, sortOrder: 'asc' };

// Client-side sort for tables that already hold every row. `keyGetters[field](row)` returns a
// string/number, or null/'' for empty — empties always go last (matches the server-side list sort).
export const sortRows = (rows, { sortBy, sortOrder }, keyGetters) => {
  const getKey = keyGetters[sortBy];
  if (!getKey) return rows;
  const direction = sortOrder === 'desc' ? -1 : 1;
  const isEmpty = (value) => value === null || value === undefined || value === '';
  return rows
    .map((row) => ({ row, key: getKey(row) }))
    .sort((a, b) => {
      const aEmpty = isEmpty(a.key);
      const bEmpty = isEmpty(b.key);
      if (aEmpty || bEmpty) return aEmpty === bEmpty ? 0 : aEmpty ? 1 : -1;
      const cmp = typeof a.key === 'string' || typeof b.key === 'string'
        ? String(a.key).localeCompare(String(b.key), undefined, { numeric: true, sensitivity: 'base' })
        : a.key - b.key;
      return cmp * direction;
    })
    .map(({ row }) => row);
};

// variant 'dark' = white text on the gradient header, 'light' = grey header row.
const ICON_COLORS = {
  dark: { active: '#e9d5ff', idle: 'rgba(255,255,255,0.65)' },
  light: { active: '#667eea', idle: '#a0aec0' },
};

const SortableTh = ({ label, field, sort, onSort, style, variant = 'dark' }) => {
  const isActive = sort.sortBy === field;
  const colors = ICON_COLORS[variant] || ICON_COLORS.dark;
  const icon = !isActive ? '↕' : sort.sortOrder === 'asc' ? '↑' : '↓';
  return (
    <th
      style={{ ...style, cursor: 'pointer', userSelect: 'none' }}
      onClick={() => onSort(field)}
      aria-sort={isActive ? (sort.sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
      title={`Sort by ${label}`}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        <span>{label}</span>
        <span style={{ color: isActive ? colors.active : colors.idle, fontSize: '10px' }}>{icon}</span>
      </span>
    </th>
  );
};

export default SortableTh;
